import { MutationType } from "@/store/mutations/type";
import { IStoreType } from "@/interfaces/IStoreType";
import { IOperator } from "@/interfaces/IOperator";

export default {
    [MutationType.SET_OPERATOR]: (state: IStoreType, val: IOperator): void => {
        state.operator = val;
      },
}